<template>
  <div>
    <QS-h4-title title="车服人员" />
    <QS-column-box
      :column="3"
      :source="data.manager"
      labelWidth="150"
      separator=":"
      :list="dm"
    >
      <template slot="avatar">
        <EnlargeImg :imgSrc="data.manager.avatar || ''" class="avatar" />
      </template>
    </QS-column-box>

    <QS-column-box
      :column="3"
      :source="data.vehicleManager"
      labelWidth="150"
      separator=":"
      :list="cm"
    >
      <template slot="avatar">
        <EnlargeImg :imgSrc="data.vehicleManager.avatar||''" class="avatar" />
      </template>
    </QS-column-box>
  </div>
</template>
<script setup>
import { ref } from 'vue'

const dm = ref([
  { key: 'avatar', name: '司管头像' },
  { key: 'userName', name: '司管姓名' },
  { key: 'userMobile', name: '司管手机' },
])

const cm = ref([
  { key: 'avatar', name: '车管头像' },
  { key: 'userName', name: '车管姓名' },
  { key: 'userMobile', name: '车管手机' },
])

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
</script>
<script>
export default {
  name: 'CarServicer',
}
</script>

